import httpClient from '@/services/http/httpClient'

export const apiPostFnolFlow = (params) => {
  return httpClient.post('fnol/', params)
    .then(data => data)
    .catch(error => Promise.reject(error))
}
